export enum ProjectsRoutesEnum {
    PROJECT_PREFIX      = 'projects',
    PROJECT_LIST        = 'projects_list',
    PROJECT_DETAIL      = 'projects_detail',
    PROJECT_ACTIVITIES  = 'project_activities',
    PROJECT_KPI         = 'projects_kpi',
    PROJECT_SHIFTS      = 'projects_shifts',
    PROJECT_TICKETS     = 'projects_tickets',
}
